import logo from './logo.svg';
import './App.css';
import Myroute from './Myroute';

function App() {
  return (
    <>
    <Myroute/>
    </>
  );
}

export default App;
